<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" :before-close="handleClose" destroy-on-close>
    <table-form :dataSource="dataSource" ref="form" :tableData="formData" @inputChange="inputChange"></table-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TableForm from 'common/components/form/tableForm'
import { step2, step5, step2Agency } from '@/conf/Report-manager'
import {
  nation,
  selectDic,
  addUpdateMes,
  saveReportMgrProduct,
  saveReportFundInvested,
  updateMgrProduct,
  updateFundInvestedNew
} from 'common/js/api'

export default {
  components: {
    TableForm
  },

  props: ['dialogVisible', 'title', 'data', 'codeId'],

  data() {
    return {
      dataSource: [],
      dialogFormVisible: false,
      formData: {},
      isManager: true,
      institutionCode: ''
    }
  },

  created() {
    // 设置配环境
    this.setEnvironment()
  },

  mounted() {
    this.setConf()
  },

  methods: {
    async getManagerSelect() {
      const query = '4,5,6'
      const result = await selectDic(query)
      const { FUND_PRODUCT_TYPE, INVEST_INDUSTRY, INVEST_PROID } = result.result

      this.converSelect(FUND_PRODUCT_TYPE, 1)
    },

    converSelect(option, index) {
      var newArray = []
      option.forEach(item => {
        let data = {
          label: item,
          value: item
        }
        newArray.push(data)
      })
      this.dataSource[index] && this.dataSource[index].options ? (this.dataSource[index].options = newArray) : ''
    },

    setEnvironment() {
      this.fillType = this.$store.state.ReportData.reportFillType
      console.log('当前的配置getFillType using', this.fillType)
      if (this.fillType == 'x') {
        this.isManager = true
      }
      if (this.fillType == 'y') {
        this.isManager = false
      }
    },

    async setConf() {
      if (this.isManager) {
        this.dataSource = step2
        await this.getManagerSelect()
        //await this.getnation();
      } else {
        this.dataSource = step2Agency
      }
    },

    async submit() {
      const isValidate = this.$refs.form.submitForm()
      if (!isValidate) return false
      let form = this.$refs.form.form

      // code id
      form.reportCode = this.codeId
      //已发行产品必传参数
      form.productType = 1
      if (this.title.includes('编辑')) {
        form.id = this.data.id
        if (this.isManager) {
          await updateMgrProduct(form)
        } else {
          let keyList = ['iskjcxorxjzz', 'ismyqy', 'issshbqy', 'iszjtx', 'isssqy']
          let extraInfo = {}
          let realForm = {}
          for (const key in form) {
            if (Object.hasOwnProperty.call(form, key)) {
              if (keyList.includes(key)) {
                this.$set(extraInfo, key, form[key])
              } else {
                this.$set(realForm, key, form[key])
              }
            }
          }
          this.$set(realForm, 'extraInfo', JSON.stringify(extraInfo))
          await updateFundInvestedNew(realForm)
        }
      } else {
        if (this.isManager) {
          await saveReportMgrProduct(form)
        } else {
          //基金机构填写默认的ID
          form.fundId = -1
          //标识已投：1 ---拟投资：0
          form.investedType = 1
          let keyList = ['iskjcxorxjzz', 'ismyqy', 'issshbqy', 'iszjtx', 'isssqy']
          let extraInfo = {}
          let realForm = {}
          for (const key in form) {
            if (Object.hasOwnProperty.call(form, key)) {
              if (keyList.includes(key)) {
                this.$set(extraInfo, key, form[key])
              } else {
                this.$set(realForm, key, form[key])
              }
            }
          }
          this.$set(realForm, 'extraInfo', JSON.stringify(extraInfo))
          await saveReportFundInvested(realForm)
        }
      }

      const message = this.title.includes('添加') ? '添加' : '编辑'
      this.$message({
        message: `已发行产品${message}成功!`,
        type: 'success'
      })
      this.$emit('reload')
      this.handleClose()
    },

    handleClose() {
      this.formData = {}
      this.dialogFormVisible = false
      this.$emit('closeDialog')
    },
    inputChange(val) {
      console.log(val)
      if (val.key === 'registeProvince') {
        console.log('registeCity进行清除')
        this.$refs.form.form.registeCity = ''
        this.$refs.form.form.registeDistrict = ''
      }
      if (val.key === 'registeCity') {
        console.log('registeDistrict进行清除')
        this.$refs.form.form.registeDistrict = ''
      }
      if (val.key === 'investProvince') {
        console.log('investCity进行清除')
        this.$refs.form.form.investCity = ''
        this.$refs.form.form.investDistrict = ''
      }
      if (val.key === 'investCity') {
        console.log('investDistrict进行清除')
        this.$refs.form.form.investDistrict = ''
      }
      this.$emit('inputChange', val)
    }
  },

  watch: {
    dialogVisible(newValue) {
      this.dialogFormVisible = newValue
      console.log(this.data)
    },
    data: {
      handler(newValue) {
        this.formData = { ...newValue }
        this.$nextTick(() => {
          let params = {
            investDistrict: newValue.investDistrict,
            registeDistrict: newValue.registeDistrict,
            registeCity: newValue.registeCity,
            investCity: newValue.investCity
          }
          if (newValue.investDistrict) {
            this.$refs.form.form.investDistrict = newValue.investDistrict
          } else if (newValue.registeDistrict) {
            this.$refs.form.form.registeDistrict = newValue.registeDistrict
          }
          if (newValue.registeCity) {
            this.$refs.form.form.registeCity = newValue.registeCity
          } else if (newValue.investCity) {
            this.$refs.form.form.investCity = newValue.investCity
          }
          this.$nextTick(() => {
            if (newValue.registeProvince) {
              let param = {
                key: 'registeProvince',
                value: newValue.registeProvince
              }
              this.inputChange(param)
            } else if (newValue.investProvince) {
              let param = {
                key: 'investProvince',
                value: newValue.investProvince
              }
              this.inputChange(param)
            }
            this.$nextTick(() => {
              if (newValue.registeCity) {
                let param = {
                  key: 'registeCity',
                  value: newValue.registeCity
                }
                this.inputChange(param)
              } else if (newValue.investCity) {
                let param = {
                  key: 'investCity',
                  value: newValue.investCity
                }
                this.inputChange(param)
              }
              this.$nextTick(() => {
                console.log("触发地区赋值")
                if (params.investDistrict) {
                  this.$refs.form.form.investDistrict = params.investDistrict
                } else if (params.registeDistrict) {
                  this.$refs.form.form.registeDistrict = params.registeDistrict
                }
                if (params.registeCity) {
                  this.$refs.form.form.registeCity = params.registeCity
                } else if (params.investCity) {
                  this.$refs.form.form.investCity = params.investCity
                }
              })
            })
          })
        })
      },
      deep: true
    }
    // isBackShow(newValue) {
    //   if(newValue) {
    //     this.dataSource = step5;
    //     this.getManagerSelect();
    //     this.getnation();
    //   }else {
    //     this.dataSource = step2;
    //     this.getManagerSelect();
    //   }
    // }
  }
}
</script>
